import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation()

  const handleClick = () => {
    // if (location.pathname === '/support'){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // }
  }

  return (
    <div className=" bg-[#1B1B1B] pt-16">
      {/* <div
        className="container p-4 mx-auto flex flex-col items-center justify-between text-white relative after:content-[''] after:w-[360px] after:left-[100%] after:h-[360px] after:bottom-[100%] after:blur-[250px] after:bg-primary after:rounded-full after:absolute after:z-[1]"
      style={{
        background: "url('/assets/backgrounds/footer_background.png')",
        backgroundSize: "100% 100%",
      }}
      > */}

      <div
        className="container p-4 mx-auto flex flex-col items-center justify-between text-white relative"
      >
        <div className="flex flex-col items-center lg:items-stretch justify-between space-y-10 lg:space-y-0 lg:flex-row lg:justify-between w-full  z-[2] max-w-[250px] sm:max-w-[400px] md:max-w-[600px] lg:max-w-[unset]">
          <div className="flex flex-col w-full max-w-[180px] lg:max-w-[350px] justify-between">
            <Link to="/">
              <img
                className="w-full max-w-[180px] lg:max-w-[315.07px]"
                src="/assets/logos/logo.svg"
                alt=""
              />
            </Link>
          </div>

          <div className="flex items-start w-full max-w-[670px]">
            <div></div>
            <div className="w-full ">
              <div className="text-base 2xl:text-xl text-white/60 mb-10 whitespace-nowrap">
                Navigation
              </div>
              <ul className="text-xs 2xl:text-base space-y-6 leading-[1.8]">
                <li className="hover:opacity-50">
                  <Link to="/" onClick={handleClick}>
                    Home
                  </Link>
                </li>

                <li className="hover:opacity-50">
                  <Link to="/marketplace/categories" onClick={handleClick}>
                    Find Cards
                  </Link>
                </li>

                <li className="hover:opacity-50">
                  <Link to="/marketplace/create-listing" onClick={handleClick}>
                    Sell Cards
                  </Link>
                </li>
              </ul>
            </div>
            <div className="w-full ">
              <p className="text-base 2xl:text-xl text-white/60 mb-10 whitespace-nowrap">
                Resources
              </p>
              <ul className="text-xs 2xl:text-base space-y-6 leading-[1.8]">
                <li className="hover:opacity-50">
                  <Link to="/faqs" onClick={handleClick}>FAQs
                  </Link>
                </li>
                <li className="hover:opacity-50">
                  <Link to="/support" onClick={handleClick}>Support
                  </Link>
                </li>
                <li className="hover:opacity-50">
                  <Link to="/login">Log In
                  </Link>
                </li>
              </ul>
            </div>
            <div className="w-full hidden lg:block">
              <div className="text-xs flex flex-col items-end justify-end 2xl:text-base space-y-6 leading-[1.8]">
                <div className="flex gap-6">
                  <div className="border-style-decoration solo-button bg-primary-gradient p-6 w-fit cursor-pointer">
                    <img alt="facebook" src="/assets/logos/facebook.svg" />
                  </div>
                  <div className="border-style-decoration solo-button bg-primary-gradient p-6 w-fit cursor-pointer">
                    <img alt="x" src="/assets/logos/x.svg" />
                  </div>
                </div>
                <div className="flex gap-6">
                  <div className="border-style-decoration solo-button bg-primary-gradient p-6 w-fit cursor-pointer">
                    <img alt="instagram" src="/assets/logos/tiktok.svg" />
                  </div>
                  <div className="border-style-decoration solo-button bg-primary-gradient p-6 w-fit cursor-pointer">
                    <img alt="instagram" src="/assets/logos/instagram.svg" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-xs flex lg:hidden items-center justify-between 2xl:text-base leading-[1.8] w-full">
            <div className="border-style-decoration solo-button bg-primary-gradient p-2 w-fit cursor-pointer">
              <img
                alt="facebook"
                src="/assets/logos/facebook.svg"
                className="max-w-[28px] lg:max-w-[unset]"
              />
            </div>
            <div className="border-style-decoration solo-button bg-primary-gradient p-2 w-fit cursor-pointer">
              <img
                alt="x"
                src="/assets/logos/x.svg"
                className="max-w-[28px] lg:max-w-[unset]"
              />
            </div>
            <div className="border-style-decoration solo-button bg-primary-gradient p-2 w-fit cursor-pointer">
              <img
                alt="instagram"
                src="/assets/logos/tiktok.svg"
                className="max-w-[28px] lg:max-w-[unset]"
              />
            </div>
            <div className="border-style-decoration solo-button bg-primary-gradient p-2 w-fit cursor-pointer">
              <img
                alt="instagram"
                src="/assets/logos/instagram.svg"
                className="max-w-[28px] lg:max-w-[unset]"
              />
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col lg:flex-row items-center justify-center space-y-8 lg:space-y-0 lg:justify-between mt-20 lg:mt-32 pb-[3rem]">
          <span className="text-white/60 font-light text-xs lg:text-sm inline-block  mr-[-1rem]">
            © 2025 Card Shop Exchange
          </span>
          <div className="flex flex-wrap gap-4 md:gap-24">
            <a
              href="/user-agreement"
              className="w-[calc(50%-8px)] md:w-auto hover:text-white text-white/60 font-light text-xs lg:text-sm"
            >
              User Agreement
            </a>
            <a
              href="/privacy-policy"
              className="w-[calc(50%-8px)] md:w-auto hover:text-white text-white/60 font-light text-xs lg:text-sm text-right md:text-left"
            >
              Privacy Policy
            </a>
            <a
              href="/return-policy"
              className="w-[calc(50%-8px)] md:w-auto hover:text-white text-white/60 font-light text-xs lg:text-sm"
            >
              Return Policy
            </a>
            <a
              href="/cookie-policy"
              className="w-[calc(50%-8px)] md:w-auto hover:text-white text-white/60 font-light text-xs lg:text-sm text-right md:text-left"
            >
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
      {/*  */}
      <div className=" overflow-hidden relative w-full h-[100px] after:content-[''] after:h-full after:top-0 after:absolute after:w-full after:max-w-[100px] lg:after:w-[500px] after:bg-[linear-gradient(to_left,#141414_0%,#14141400_100%)] after:right-0  after:pointer-events-none  before:content-['']  before:absolute before:h-full before:w-full before:max-w-[100px] lg:before:w-[500px] before:left-0 before:bg-[linear-gradient(to_left,#14141400_0%,#141414_100%)] z-10 before:z-20  before:pointer-events-none">
        <div className="items-center animate-marquee w-fit flex">
          <span className="flex font-aero leading-[1]  gradient-text uppercase text-[64px] lg:text-[92px] whitespace-nowrap pr-6 pl-1">
            card shop exchange?
          </span>
          <span className="flex font-aero leading-[1]  text-white uppercase text-[64px] lg:text-[92px] whitespace-nowrap pr-6">
            card shop exchange?
          </span>
          <span className="flex font-aero leading-[1]  gradient-text uppercase text-[64px] lg:text-[92px] whitespace-nowrap pr-6 pl-1">
            card shop exchange?
          </span>
          <span className="flex font-aero leading-[1]  text-white uppercase text-[64px] lg:text-[92px] whitespace-nowrap pr-6">
            card shop exchange?
          </span>
        </div>
      </div>
      <br />
    </div>
  );
};

export default Footer;
